import { useLayoutEffect, useRef } from 'react';
import { NavigationType, useLocation, useNavigationType } from 'react-router-dom';

import { startPageView } from '../hooks/useGuideLinkTracking';

/**
 * Tells feature-link tracking when a page view starts (GDN-3705, AC-15): when
 * the pathname changes, and on a back or forward navigation, which returns to
 * a page seen earlier. A push or replace that only rewrites the query string
 * on the same pathname (a tab, a filter, the reader stripping its referrer)
 * stays within the view. Renders nothing. Mount it first in the authenticated
 * layout: its layout effect then runs before any link's passive effect on the
 * same navigation.
 */
export function PageViewObserver() {
  const location = useLocation();
  const navigationType = useNavigationType();
  const lastPathname = useRef<string | undefined>(undefined);
  useLayoutEffect(() => {
    const pathnameChanged = lastPathname.current !== location.pathname;
    if (pathnameChanged || navigationType === NavigationType.Pop) startPageView();
    lastPathname.current = location.pathname;
  }, [location.pathname, location.key, navigationType]);
  return null;
}
